import State from './state';

export function getChildSelectedRewards(state = State) {
  return (id) => {
    return state.child_rewards[id];
  };
}

export function getParentRewards(state = State) {
  return (id) => {
    return state.parent_rewards[id];
  };
}

export function getParentPoints(state = State) {
  return state.parent_points;
}

export function rewardsIdeas(state = State) {
  return state.rewardsIdeas || [];
}
